import { render, staticRenderFns } from "./GoogleReview.vue?vue&type=template&id=796ec5ac&scoped=true"
import script from "./GoogleReview.vue?vue&type=script&lang=js"
export * from "./GoogleReview.vue?vue&type=script&lang=js"
import style0 from "./GoogleReview.vue?vue&type=style&index=0&id=796ec5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ec5ac",
  null
  
)

export default component.exports